export function NoRecordField(data) {
  return !data ? "-" : data;
}
